export default {
  title: 'Jednotky',

  Table: {
    Header: {
      unit: 'jednotka',
      owner: 'vlastník',
    },
    Body: {
      unit: 'Jednotka',
    },

    ownersCount_zero: '',
    ownersCount_one: 'Další {{count}} vlastník',
    ownersCount_few: 'Další {{count}} vlastníci',
    ownersCount_other: 'Dalších {{count}} vlastníků',
  },

  Default: {
    Header: {
      exportContactsAction: 'Exportovat kontakty',
      importContactsAction: 'Importovat kontakty',
      presenceListAction: 'Stáhnout prezenční listinu',
    },

    PresenceList: {
      error: 'Prezenční listinu se nepodařilo stáhnout, zkuste to prosím znovu.',
      WarningModal: {
        title: 'Prezenční listina nemusí být aktuální',
        text: 'Váš dům nemá aktivní licenci — změny vlastníků z katastru nemovitostí se nepromítají do evidence jednotek a aktuálnost prezenční listiny proto nemůžeme garantovat.',
        upsell:
          'S aktivní licencí pravidelně kontrolujeme katastr nemovitostí a všechny zjištěné změny propisujeme do aplikace — prezenční listina je tak vždy aktuální.',
        order: 'Objednat služby',
        downloadAnyway: 'Přesto stáhnout',
      },
    },

    ModalExport: {
      title: 'Export kontaktů byl stažen',
      subtitle: 'Export slouží výhradně k doplnění kontaktních údajů vlastníků — e-mailu a telefonu.',
      rule_1:
        'V souboru doplňte pouze e-mail a telefon. Ostatní sloupce potřebuje systém k přiřazení kontaktů ke správnému vlastníkovi — neměňte je, stejně jako počet a pořadí sloupců.',
      rule_2: 'E-mail musí být u každého vlastníka jedinečný, slouží zároveň jako přihlašovací jméno do aplikace.',
      confirm: 'Rozumím',
      error: 'Export kontaktů se nezdařil, zkuste to prosím znovu.',
    },

    ModalImport: {
      title: 'Importovat kontakty',
      subtitle_1: 'Import kontaktů slouží k hromadnému doplnění, či změně kontaktních údajů vlastníků.',
      subtitle_2:
        'Doporučujeme vám v prvním kroku stáhnout export kontaktů, doplnit údaje a následně soubor zpět naimportovat (formát XLSX).',
      subtitle_3:
        'Dodržujte (neměňte) pořadí jednotlivých sloupců. Aplikace v průběhu importu doplní, či zaktualizuje pouze kontaktní e-mail a telefonní kontakt.',

      submit: 'Importovat kontakty',
      formError: 'Při importu došlo k chybě, zkontrolujte prosím zadané údaje a soubor nahrajte znovu.',
      BadFormats: {
        email: 'emailu',
        phone: 'telefonu',
        profileId: 'ProfileId',
      },
      Attachment: {
        label: 'Vybrat soubor',
        filesLabel: 'Pro dokončení nahrávání klikněte na tlačítko níže.',
      },

      Flash: {
        importSuccess: 'Import kontaktu proběhl v pořádku.',
      },
    },
  },

  RepresentativeForm: {
    error: 'Zástupce se nepodařilo uložit. Zkontrolujte prosím zadané údaje.',
    invalid: 'Formulář není kompletní — vyberte zástupce, nebo vyplňte údaje nové osoby.',
    EmailCheck: {
      owner:
        'Uživatel s tímto e-mailem je vlastníkem jednotky v tomto domě — vyberte ho prosím přímo v seznamu členů (zrušte volbu osoby mimo dům). S tímto e-mailem formulář nelze odeslat.',
      member:
        'Uživatel s tímto e-mailem už je členem tohoto domu — zastoupení se naváže na jeho stávající účet (jméno se převezme z účtu) a pozvánka se mu posílat nebude.',
      existing:
        'Uživatel s tímto e-mailem už v aplikaci existuje — zastoupení se naváže na jeho stávající účet (jméno se převezme z účtu) a pozvánka se mu posílat nebude.',
    },
    Groups: {
      members: 'Členové domu',
      unitOwners: 'Spoluvlastníci jednotky',
      others: 'Ostatní členové domu',
    },
    Fields: {
      member: {
        label: 'Vyberte zástupce z členů domu',
        placeholder: 'Hledat podle jména nebo čísla jednotky',
      },
      isNewPerson: {
        label: 'Zástupcem bude osoba mimo dům (zadáte ji e-mailem)',
      },
      firstName: { label: 'Jméno' },
      lastName: { label: 'Příjmení' },
      email: { label: 'E-mail (novému uživateli pošleme pozvánku do aplikace)' },
      phone: { label: 'Telefon (pro SMS potvrzení hlasování)' },
      validTo: { label: 'Platnost do (nepovinné — prázdné = neomezeně)' },
      documents: {
        label: 'Plná moc / zmocnění (PDF nebo foto, nepovinné)',
        filesLabel: 'Vybrané soubory',
      },
    },
  },
  ProfileDetail: {
    title: 'Detail vlastníka',
    Header: {
      title: 'Upravit informace o vlastníkovi',
    },
    Tabs: {
      overview: 'Přehled',
      proxy: 'Plná moc',
    },
    VotingProxy: {
      title: 'Plná moc k hlasování',
      description:
        'Vlastník může zmocnit jinou osobu, aby za něj hlasovala — za všechny jeho jednotky včetně případných spoluvlastnických podílů. Vlastník může i nadále hlasovat sám; platí hlas, který je potvrzen jako první.',
      current: 'Zmocněnec: {{name}}',
      validTo: 'platí do {{date}}',
      add: 'Udělit plnou moc',
      end: 'Ukončit plnou moc',
      ended: 'Plná moc byla ukončena.',
      success: 'Plná moc byla zaevidována.',
      submit: 'Zaevidovat plnou moc',
    },
    EmailCheck: {
      taken:
        'Uživatel s tímto e-mailem už v aplikaci existuje — stejný e-mail nelze uložit dalšímu vlastníkovi. Pokud má za tohoto vlastníka hlasovat, zadejte mu',
      takenLink: 'plnou moc',
    },
    State: {
      new: {
        title: 'Nový vlastník — zatím nemá přístup do aplikace',
        text: 'Vyplňte vlastníkovi e-mail i telefon — oba kontakty jsou potřeba, aby bylo hlasování právně závazné. Pozvánka do aplikace se odesílá automaticky se zahájením prvního hlasování. Jakmile ale kontakty uložíte, můžete vlastníka pozvat i ručně.',
      },
      invited: {
        title: 'Pozvánka byla odeslána {{date}}',
        text: 'Vlastník pozvánku do aplikace zatím nepřijal. Pokud ji nemůže najít, můžete mu ji kdykoli odeslat znovu.',
      },
      registered: {
        title: 'Vlastník je registrovaný v aplikaci',
        text: 'Kontaktní údaje už nemůžete upravovat — za jejich správnost odpovídá sám vlastník. Pokud je přesto potřeba je změnit, obraťte se na',
        link: 'pomoc',
      },
    },
    Form: {
      Flash: {
        success: 'Úprava profilu proběhla úspěšně.',
        error: 'Úprava profilu se nezdařila, zkuste to prosím znovu.',
      },
      Fields: {
        FirstName: {
          label: 'Jméno',
          placeholder: 'Jméno vlastníka není v katastru nemovitostí k dispozici',
          required: 'Jméno musí být vyplněné',
        },
        LastName: {
          label: 'Příjmení',
          placeholder: 'Příjmení vlastníka není v katastru nemovitostí k dispozici',
          required: 'Příjmení musí být vyplněné',
        },
        Company: {
          label: 'Společnost',
          placeholder: 'Název společnosti není v katastru nemovitostí k dispozici',
          required: 'Název společnosti musí být vyplněn',
        },
        Email: {
          label: 'Email',
          placeholder: 'Email vlastníka',
        },
        Phone: {
          label: 'Telefon',
          placeholder: 'Telefon vlastníka',
          required: 'Telefon je povinný',
        },
        Birthday: {
          label: 'Datum narození',
          placeholder: 'Datum narození vlastníka není k dispozici',
        },
        BirthNumber: {
          label: 'Rodné číslo',
          placeholder: 'Rodné číslo není v katastru nemovitostí k dispozici',
        },
        Submit: {
          title: 'Uložit změny',
        },
      },
    },
    InvitationModal: {
      linkTitle: 'Odeslat pozvánku do aplikace',
      linkTitleResend: 'Znovu odeslat pozvánku',
      title: 'Opravdu chcete odeslat pozvánku?',
      subtitle: 'Pozvánky se automaticky rozesílají uživatelům při publikování hlasování.',
      confirm: 'Odeslat',
      Flash: {
        success: 'Pozvánka byla úspěšně odeslána',
        error: 'Pozvánku se nepodařilo odeslat',
      },
    },
  },

  UnitDetail: {
    title: 'Detail jednotky',
    Header: {
      title: 'Jednotka',
    },
    Form: {
      submit: 'Uložit',
      cancel: 'Zrušit',
      success: 'Nastavení jednotky bylo úspěšně uloženo.',
      error: 'Úprava jednotky se nezdařila, zkuste to prosím znovu.',
      Fields: {
        UseType: {
          label: 'Způsob využití',
          placeholder: 'Zadejte využití jednotky',
        },
        Address: {
          label: 'Adresa jednotky',
          placeholder: 'Zadejte adresu jednotky',
        },
        Owners: {
          label: 'Vlastníci jednotky',
        },
        share: 'Podíl na společných prostorách',

        VotingStrategy: {
          label: 'Typ hlasování za tuto jednotku',
          change: 'Změnit typ hlasování',
          short_default: 'První hlasuje za jednotku',
          short_separateVoting: 'Oddělené hlasování',
          short_excludedFromVoting: 'Vyloučena z hlasování',
          default: 'první z hlasujících odhlasuje za celou jednotku',
          default_description:
            'V případě, že přístup do aplikace má více vlastníků jednotky, ten který odhlasuje jako první, hlasuje za celý podíl jednotky. Ostatní spoluvlastníci musí dodat zmocnění tohoto vlastníka, jinak nelze hlas započítat! V případě, že stanovy nevyžadují udělení plné moci, může být zmocnění udělené jakýmkoliv písemným způsobem - např. i elektronicky (e-mailem).',
          separateVoting: 'oddělené hlasování v jednotce (přičtení k celku na konci)',
          separateVoting_description:
            'U tohoto typu hlasování aplikace spočítá nejdříve hlasy spoluvlastníků v dané jednotce (s respektováním síly dle podílů v jednotce) a výsledek pak přičte k celkovému hlasování v domě po ukončení hlasování (se zachováním nastaveného kvóra pro přijetí daného usnesení). Konstatujeme, že zákon připouští v případě více spoluvlastníků pouze hlasování přes zmocněného zástupce a tedy tento typ hlasování nemá oporu v zákoně.',
          excludedFromVoting: 'vyloučení jednotky z hlasování',
          excludedFromVoting_description:
            'Pokud je u jednotky více spoluvlastníků, kteří z jakéhokoliv důvodu neurčí společného zástupce, neměl by být hlas za tuto jednotku vůbec do hlasování započítán. V případě volby tohoto typu hlasování nebude podíl jednotky do hlasování započítán - aplikace se zachová tak, jakoby tato jednotka vůbec nehlasovala (nezávisle na odeslaných hlasech spoluvlastníků). Sníží se tím ale samozřejmě pravděpodobnost přijetí navrhovaného usnesení.',
          designatedVoter: 'společný zástupce jednotky',
          designatedVoter_description:
            'Spoluvlastníci jednotky určí jednoho společného zástupce (§ 1185 odst. 2 občanského zákoníku), který hlasuje za celý podíl jednotky. Zástupcem může být i osoba mimo jednotku či dům (např. předseda SVJ). Toto je jediný typ hlasování více spoluvlastníků s plnou oporou v zákoně — doporučujeme doložit písemné zmocnění (lze nahrát níže).',
          short_designatedVoter: 'Společný zástupce',
        },
      },
    },
    DesignatedVoter: {
      current: 'Společný zástupce: {{name}}',
      validTo: 'platí do {{date}}',
      end: 'Ukončit zastoupení',
      ended: 'Zastoupení bylo ukončeno, jednotka se vrátila k původnímu typu hlasování.',
      success: 'Společný zástupce jednotky byl nastaven.',
      submit: 'Nastavit společného zástupce',
      replaceHint: 'Nastavením nové osoby níže se stávající zastoupení ukončí a nahradí.',
      consentTipTitle: 'Nezapomeňte na souhlas spoluvlastníků',
      consentTip:
        'K určení společného zástupce stačí souhlas většiny spoluvlastníků jednotky počítané podle velikosti jejich podílů — souhlas všech není potřeba. U manželů s jednotkou ve společném jmění (SJM) stačí, když zástupce určí jeden z nich. Doporučujeme zmocnění doložit písemně a dokument nahrát níže.',
    },
    Tabs: {
      overview: 'Přehled',
      files: 'Soubory',
      history: 'Historie z rejstříků',
    },
    Stats: {
      voting: 'Typ hlasování',
      shareOfBuilding: 'tj. {{percent}} % z domu',
    },
    History: {
      emptyTitle: 'U této jednotky zatím neevidujeme žádné změny',
      emptyText:
        'Katastr nemovitostí i další rejstříky pravidelně kontrolujeme. Jakmile u jednotky nebo jejích vlastníků zachytíme změnu, zobrazíme ji zde a upozorníme vás.',
    },
    Files: {
      title: 'Soubory jednotky',
      upload: 'Nahrát soubor',
      empty:
        'K jednotce zatím nebyly nahrány žádné soubory. Můžete jí sem uložit např. vyúčtování, předpis záloh nebo odečty měřidel.',
      visibility: 'Soubory vidí vlastníci jednotky ve svém Úložišti souborů.',
      ModalUpload: {
        title: 'Nahrát soubory jednotce',
        subtitle:
          'Soubory se uloží k této jednotce. Uvidí je jen její vlastníci, kterým zároveň odejde e-mailové upozornění.',
        submit: 'Nahrát',
        formError: 'Soubory se nepodařilo nahrát, zkuste to prosím znovu.',
        success: 'Soubory byly úspěšně nahrány k jednotce.',
        Category: {
          label: 'Kategorie souborů',
        },
        Attachment: {
          label: 'Vybrat soubory',
        },
      },
    },
  },
};
